import Vue from 'vue'
import Vuex from 'vuex'

import { errors } from './errors';
import { language } from './language';
import { loader } from './loader';
import { nav } from './nav';
import { translate } from './translate';
import { translations } from './translations';
import { dictionaries } from './dictionary';
import { notifications } from './notification';
import { model } from './model';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    errors,
    language,
    loader,
    nav,
    translate,
    translations,
    dictionaries,
    notifications,
    model
  },
  plugins: []
});
